var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wdg-button"},[_c('button',{class:_vm.color,attrs:{"type":_vm.type,"id":_vm.id,"disabled":_vm.disabled},on:{"click":_vm.onClickLocalEvent}},[_vm._t("label")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }